import * as React from 'react'

import { ContactUs } from 'sdk/contact-us/ContactUs'
import { Button } from 'sdk/button/Button'

import { CONTACT_FORM_URL } from 'core/constants'

export const ContactUsSection: React.FC = () => (
  <ContactUs
    text="Reach out to us to learn more, get answers to questions, schedule a meeting or demo"
    button={(
      <Button
        as="link"
        target="_blank"
        href={CONTACT_FORM_URL}
      >
        Contact Us
      </Button>
    )}
  />
)
